import { Quest } from "./Quest";

export class Quests extends Map<string, Quest> {}
